






























































































import {Vue, Component, Prop, Ref, Watch} from "vue-property-decorator"
import GenericTemplate from "@/pages/Pages/Templates/GenericTemplate.vue";
import {MsgTransports} from "@/store/types";
import {Route} from "vue-router";
import SmsTextInputWings from "@/components/SMS/SmsTextInputWings.vue";
import { SelectWings, FieldTooltip, TextareaWings } from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {MailNotifyTemplateItemImpl} from "@/store/mail_notify/templates/types";
import CascadingOptions from "@/components/Others/CascadingOptions.vue";

Component.registerHooks(["beforeRouteLeave"]);

@Component({components: {CascadingOptions, FieldTooltip, SmsTextInputWings, GenericTemplate, SelectWings, TextareaWings}})
export default class MNTemplate extends Vue {

  @Prop() moderation!: boolean;

  @Ref("genericTemplate") genericTemplate!: GenericTemplate;

  @Action("getManagementServices") actionGetManagementServices: any;
  @Action("getManagementTemplates") actionGetManagementTemplates: any;

  @Getter("managementServices") managementServicesList: any;
  @Getter("managementTemplates") managementTemplatesList: any;
  @Getter("mnRoutesList") mnRoutesList: any;
  @Getter("getPartnerById") getPartnerNameById: any;

  private transport: MsgTransports = MsgTransports.MAILNOTIFY;
  private templateObject: MailNotifyTemplateItemImpl = new MailNotifyTemplateItemImpl();
  private mnTemplatesList = [];

  created() {
    this.actionGetManagementTemplates();
  }

  get mnServicesList() {
    return this.managementServicesList.filter((item:any) => item.status);
  }

  @Watch('templateObject.routes', {immediate: true, deep:true})
  onRoutesChange(val: string) {
    if (!val) return
    if (!val.includes('vk')) {
      this.templateObject.vk_message = '';
    }
    if (!val.includes('ok')) {
      this.templateObject.ok_message = '';
    }
  }

  @Watch('templateObject.mn_service_id', {immediate: true, deep:true})
  onMnServiceIdChange(val: string, newVal: string) {
    this.changeMNTemplateList();
    if (val && newVal && val!=newVal) {
      this.templateObject.mn_template_id = null;
    }
  }

  @Watch('templateObject.mn_template_id', {immediate: true})
  onMnTemplateIdChange(val: string) {
    if (val)  {
      this.templateObject.routes = 'vk,ok'
      this.templateObject.vk_message = '';
      this.templateObject.ok_message = '';
    }
  }

  @Watch('templateObject.partner_id', { immediate: true })
  async onTemplateChangePartner(newVal: number, oldVal?: number) {
    if (this.templateObject.partner_id){
      const partner = this.getPartnerNameById(this.templateObject.partner_id);
      await this.actionGetManagementServices({ partner: partner?.name });
    }
    if (oldVal && newVal !== oldVal) this.templateObject.mn_service_id = null;
  }

  onChangeTemplate(data: any){
    this.templateObject = data;
    this.changeMNTemplateList();
  }

  changeMNTemplateList(): void{
    this.mnTemplatesList = this.managementTemplatesList.filter((item:any) => item.mn_service_id == this.templateObject.mn_service_id);
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }
}
